import { TextCell } from '@ayocore/platform/client/components/EditableGrid';
import type { SupplierQuoteColumnKey, SupplierQuoteLike, SupplierQuotePatch } from './types';

export const quoteNotesColumn = TextCell<
  SupplierQuoteLike,
  SupplierQuotePatch,
  SupplierQuoteColumnKey
>({
  key: 'notes',
  title: 'Примечания',
  multiline: true,
  dimmed: true,
});
